(function() {
    'use strict';

    angular.module('remitEventsApp').controller('TabsController', function($css, $scope, $state, $stateParams, Content) {
        var vm = this;
        var tabs = [
            {
                title: 'remitEventsApp.tabs.unavailability',
                availableCommodities: ['energy', 'gas'],
                disabled: false,
                active: false
            },
            {
                title: 'remitEventsApp.tabs.others',
                availableCommodities: 'others',
                commodity: 'others',
                disabled: false,
                active: false
            }
        ];
        var contractor = $stateParams.contractor ? $stateParams.contractor : 'all';

        vm.feedChanel = 'all';
        vm.tabs = [];

        vm.go = function(tab) {
            $state.go(tab.availableCommodities === 'others' ? 'event-others' : 'event', {
                commodity: $stateParams.commodity,
                contractor: tab.contractor ? tab.contractor : contractor
            });
        };

        vm.$onInit = function() {
            var isOthers = $state.current.data.otherEvents;
            var stateCommodity = isOthers ? 'others' : $stateParams.commodity;
            var commodityTabIndex = _.findIndex(tabs, function(tab) {
                var commodities = tab.availableCommodities;

                return _.isArray(commodities) ? commodities.indexOf(stateCommodity) !== -1 : commodities === stateCommodity;
            });

            if (commodityTabIndex !== -1) {
                tabs[0].commodity = stateCommodity;
            } else {
                commodityTabIndex = 0;
                $state.go('event', { commodity: 'energy', contractor: contractor });
            }

            vm.tabs = tabs;
            vm.commodityTabIndex = commodityTabIndex;
            vm.feedChanel = contractor !== 'production' ? contractor : 'all';

            $css.removeAll();
            $css.add(Content.getContractorCss());
        };
    });
})();
